<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { getContext } from 'svelte';

    let { itemIdentifier, attributes = {} } = $props();

    // svelte-ignore state_referenced_locally
    const itemContext = getContext(itemIdentifier);
    const assetManager = itemContext && itemContext.getAssetManager();

    // svelte-ignore state_referenced_locally
    const resolvedAttributes = Object.assign({}, attributes, {
        src: assetManager ? assetManager.resolve(attributes.src) : attributes.src
    });
</script>

<track {...resolvedAttributes} />
